var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.36 13.41",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.09 12 3.84 7.71h17.52v-2H3.8l4.29-4.3L6.67 0 0 6.67l6.67 6.74z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left.caa42aacafa43a885ff82efbc98182ad.svg";